import React, { useEffect, useState, useCallback, useRef} from "react";
import makeRequest,{makeFormDataRequest} from "../../../api/makeRequest";
import { useTranslation } from "react-i18next";
import MyModal from "../../MyModal";
import MyForm from "../../MyForm";
import {Section , Input , Sumbit} from "../../MyForm/MyForm";
import LoadingIcon from "../../../../icons/LoadingIcon";
import MessageBox from "../../MessageBox";
import FolderItem from "./FolderItem";
import LibraryFile from "../LibraryFile";

const LibraryFolder = ({match}) => {
    
    const folderId = match.params.fid || ''
    const name = match.params.name || ''

    const fileInput = useRef();

    const { t } = useTranslation('common')

    const [itemId,setItemId] = useState('');
    const [targetFolder,setTargetFolder] = useState('')
    const [popup,setPopup] = useState('');
    const [noform, setNoform] = useState(0);
    const [errMessage,setErrMessage] = useState('');
    const [successMessage,setSuccessMessage] = useState('');
    const [Loading, setLoading] = useState(false);
    const [Folders, setFolders] = useState([]);
    const [Files, setFiles] = useState([]);
    const [formName,setFormName] = useState('');
    const [formFile,setFormFile] = useState(null);
    const [progress,setProgress] = useState(0);
    const getFilesAndFolders = async () => {
        //fetch f&f 
        try {
            setLoading(true);
            const { data } = await makeRequest('filesAndFolders', { folder: folderId })
            const { folders,files } = data;
            setFolders(folders);
            setFiles(files);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }
    const createFolder = async (name) => {
        try {
            setLoading(true);
            const { data } = await makeRequest('createFolder', { name,folder:folderId })
            const { success } = data;
            if (success) {
                const { folder } = data;
                setFolders(p => [...p, folder])
                setSuccessMessage('پوشه ساخته شد.')
                setTimeout(()=>{
                    setPopup('');
                },1000);
            } else {
                const {error} = data;
                setErrMessage(error ? error : 'مشکلی پیش آمده !')
            }
        } catch (e) {
            console.error(e);
            setErrMessage('مشکلی پیش آمده !')
        } finally {
            setLoading(false);
        }
    }
    const createFile = async (name,file) => {
        try {
            setLoading(true);
            const formData = new FormData();
            formData.append('method','createFile');
            formData.append('name',name);
            if(folderId) formData.append('folder',folderId);
            formData.append('file2',file);
            const { data } = await makeFormDataRequest('panel/data', formData,{},'', {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
                onUploadProgress: data => {
                  //Set the progress value to show the progress bar
                  setProgress(Math.round((100 * data.loaded) / data.total))
                },
              });
            const { success } = data;
            if (success) {
                const { file } = data;
                setFiles(p => [...p, file])
                setSuccessMessage('فایل آپلود شد.')
                setTimeout(()=>{
                    setPopup('');
                    setProgress(0);
                },1000);
            } else {
                const {error} = data;
                setErrMessage(error ? error : 'مشکلی پیش آمده !')
            }
        } catch (e) {
            console.error(e);
            setErrMessage('مشکلی پیش آمده !')
        } finally {
            setLoading(false);
        }
    }
    const editFolder = async (id,name) => {
        try {
            setLoading(true);
            const { data } = await makeRequest('editFolder', { name,id })
            const { success } = data;
            if (success) {
                setFolders(p => {
                    p = p.map(f=>{
                        if(f._id === id) f.name = name;
                        return f;
                    })
                    return p;
                })
                setSuccessMessage('پوشه ویرایش شد.')
                setTimeout(()=>{
                    setPopup('');
                },1000);
            } else {
                const {error} = data;
                setErrMessage(error ? error : 'مشکلی پیش آمده !')
            }
        } catch (e) {
            console.error(e);
            setErrMessage('مشکلی پیش آمده !')
        } finally {
            setLoading(false);
        }
    }
    const editFile = async (id,name) => {
        try {
            setLoading(true);
            const { data } = await makeRequest('editFile', { name,id })
            const { success } = data;
            if (success) {
                setFiles(p => {
                    p = p.map(f=>{
                        if(f.id === id) f.name = name;
                        return f;
                    })
                    return p;
                })
                setSuccessMessage('فایل ویرایش شد.')
                setTimeout(()=>{
                    setPopup('');
                },1000);
            } else {
                const {error} = data;
                setErrMessage(error ? error : 'مشکلی پیش آمده !')
            }
        } catch (e) {
            console.error(e);
            setErrMessage('مشکلی پیش آمده !')
        } finally {
            setLoading(false);
        }
    }
    const deleteFolder = async (id) => {
        try {
            setLoading(true);
            const { data } = await makeRequest('deleteFolder', { id })
            const { success } = data;
            if (success) {
                setFolders(p => p.filter(q=>q._id !== id))
                setSuccessMessage('پوشه حذف شد.')
                setTimeout(()=>{
                    setPopup('');
                },1000);
            } else {
                const {error} = data;
                setErrMessage(error ? error : 'مشکلی پیش آمده !')
            }
        } catch (e) {
            console.error(e);
            setErrMessage('مشکلی پیش آمده !')
        } finally {
            setLoading(false);
        }
    }
    const deleteFile = async (id) => {
        try {
            setLoading(true);
            const { data } = await makeRequest('deleteFile', { id })
            const { success } = data;
            if (success) {
                setFiles(p => p.filter(q=>q.id !== id))
                setSuccessMessage('فایل حذف شد.')
                setTimeout(()=>{
                    setPopup('');
                },1000);
            } else {
                const {error} = data;
                setErrMessage(error ? error : 'مشکلی پیش آمده !')
            }
        } catch (e) {
            console.error(e);
            setErrMessage('مشکلی پیش آمده !')
        } finally {
            setLoading(false);
        }
    }
    const moveFile = async (id,folder) => {
        try {
            setLoading(true);
            const { data } = await makeRequest('moveFile', { id,folder })
            const { success } = data;
            if (success) {
                setFiles(p => p.filter(q=>q.id !== id))
                setSuccessMessage('فایل منتقل شد.')
                setTimeout(()=>{
                    setPopup('');
                },1000);
            } else {
                const {error} = data;
                setErrMessage(error ? error : 'مشکلی پیش آمده !')
            }
        } catch (e) {
            console.error(e);
            setErrMessage('مشکلی پیش آمده !')
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        const doAsync = async () => {
            await getFilesAndFolders(folderId);
        };
        doAsync();
    }, [match]);
    const setValueOfForm = useCallback((setter, e) => {
		const {value} = e.target
		setter(value)
	}, [])
    const submitForm = async (e)=>{
        e.preventDefault();
        setErrMessage('');
        setSuccessMessage('');
        switch(noform){
            case 0:
                //createFolder
                if(!formName || formName === ' ') {
                    setErrMessage('نام پوشه الزامی است .');
                    return;
                }
                createFolder(formName)
                break;
            case 1:
                //createFile
                if(!formName || formName === ' ') {
                    setErrMessage('نام فایل الزامی است .');
                    return;
                }
                if(!formFile) {
                    setErrMessage('فایل الزامی است .');
                    return;
                }
                //TODO : Check Extentions and Size Of File

                createFile(formName,formFile)
                break;
            case 2:
                //editFolder
                if(!formName || formName === ' ') {
                    setErrMessage('نام پوشه الزامی است .');
                    return;
                }
                editFolder(itemId,formName)
                break;
            case 3:
                //editFile
                if(!formName || formName === ' ') {
                    setErrMessage('نام فایل الزامی است .');
                    return;
                }
                editFile(itemId,formName)
                break;
            case 4:
                //deleteFolder
                deleteFolder(itemId)
                break;
            case 5:
                //deleteFile
                deleteFile(itemId)
                break;
            case 6:
                //moveFile
                moveFile(itemId,targetFolder)
                break;
        }
    }
    const createForm = ()=>{
        switch(noform){
            case 0:
                //createFolder
                return (
                    <>
                        <Section title='مشخصات پوشه'>
                            <Input
                                name='name'
                                label={t('Name')}
                                full={true}
                                placeholder='Riazi10'
                                defaultValue={formName}
                                required
                                onChange={(e) => setValueOfForm(setFormName, e)}
                            />
                        </Section>
                        <Sumbit loading={Loading} align='left'>{Loading ? <LoadingIcon/> : "ساخت پوشه"}</Sumbit>
                    </>
                )
            case 1:
                //createFile
                return (
                    <>
                        <Section title='مشخصات فایل'>
                            <Input
                                name='name'
                                label={t('Name')}
                                full={true}
                                placeholder='FileName'
                                defaultValue={formName}
                                required
                                onChange={(e) => setValueOfForm(setFormName, e)}
                            />
                            <input
                                ref={fileInput}
                                type='file'
                                onChange={(e) => setFormFile(e.target.files[0])}
                                />
                            <div className='library-progress-bar' style={{width:progress+"%"}}/>
                        </Section>
                        <Sumbit loading={Loading} align='left'>{Loading ? <LoadingIcon/> : "ارسال فایل"}</Sumbit>
                    </>
                )
            case 2:
                //editFolder
                return (
                    <>
                        <Section title='مشخصات پوشه'>
                            <Input
                                key={itemId}
                                name='name'
                                label={t('Name')}
                                full={true}
                                placeholder='FileName'
                                defaultValue={formName}
                                required
                                onChange={(e) => setValueOfForm(setFormName, e)}
                            />
                        </Section>
                        <Sumbit loading={Loading} align='left'>{Loading ? <LoadingIcon/> : "ویرایش پوشه"}</Sumbit>
                    </>
                )
            case 3:
                //editFile
                return (
                    <>
                        <Section title='مشخصات فایل'>
                            <Input
                                key={itemId}
                                name='name'
                                label={t('Name')}
                                full={true}
                                placeholder='FileName'
                                defaultValue={formName}
                                required
                                onChange={(e) => setValueOfForm(setFormName, e)}
                            />
                        </Section>
                        <Sumbit loading={Loading} align='left'>{Loading ? <LoadingIcon/> : "ویرایش فایل"}</Sumbit>
                    </>
                )
            case 4:
                //deleteFolder
                return (
                    <>
                        <Section title='مشخصات پوشه'>
                            <h3>{formName}</h3>
                            <p>آیا اطمینان دارید ؟</p>
                        </Section>
                        <Sumbit loading={Loading} align='left'>{Loading ? <LoadingIcon/> : "حذف پوشه"}</Sumbit>
                    </>
                )
            case 5:
                //deleteFile
                return (
                    <>
                        <Section title='مشخصات فایل'>
                            <h3>{formName}</h3>
                            <p>آیا اطمینان دارید ؟</p>
                        </Section>
                        <Sumbit loading={Loading} align='left'>{Loading ? <LoadingIcon/> : "حذف فایل"}</Sumbit>
                    </>
                )
            case 6:
                //moveFile
        }
    }
    useEffect(()=>{
        setSuccessMessage('');
    },[popup])
    return (
        <div className='library-folder-wrap'>
            <MyModal active={popup} header={popup} onClose={() => setPopup('')}>
                {errMessage && <MessageBox message={errMessage} type='error'/>}
                {successMessage && <MessageBox message={successMessage}/>}
                <MyForm onSubmit={submitForm}>
                    {createForm()}
                </MyForm>
            </MyModal>
            <h3>{name ? name : t('MainFolder')}</h3>
            <button onClick={()=>{
                setPopup(t('NewFolder'));
                setFormName('');
                setNoform(0);
            }}>{t('NewFolder')}</button>
            <button onClick={()=>{
                setPopup('فایل جدید');
                setFormName('');
                setFormFile(null);
                if(fileInput.current) fileInput.current.value = "";
                setNoform(1);
            }}>{t('NewFile')}</button>
            <div className='library-list'>
                {/* Files and Folders */}
                {Folders.map(f => (
                    <FolderItem
                        onEdit={()=>{
                            setPopup('ویرایش پوشه');
                            setFormName(f.name);
                            setNoform(2);
                            setItemId(f._id)
                        }}
                        onDelete={()=>{
                            setPopup('حذف پوشه');
                            setFormName(f.name);
                            setNoform(4);
                            setItemId(f._id)
                        }}
                        key={f._id}
                        folder={f}
                    />
                ))}
                {Files.map(f => (
                    <LibraryFile
                        onEdit={()=>{
                            setPopup('ویرایش فایل');
                            setFormName(f.name);
                            setNoform(3);
                            setItemId(f.id)
                        }}
                        onDelete={()=>{
                            setPopup('حذف فایل');
                            setFormName(f.name);
                            setNoform(5);
                            setItemId(f.id)
                        }}
                        key={f._id}
                        file={f}
                    />
                ))}
            </div>
        </div>
    )
}
export default LibraryFolder;